const STORAGE_KEYS = {
    COOKIE_NOTIFICATION: 'cookieNotification',
    HIDE_WISH_LIST_INFO_CARD: 'hideWishListInfoCard',
    ITEMS_CLICK: 'items-click',
    SAVE_SEARCH_HINT: 'save-search-tooltip',
    SEARCH_RECENT: 'search-recent',
    WEB_PUSH_ACCEPTED: 'web_push_accepted',
    WEB_PUSH_SHOWN_MODALS: 'webPushModalsShown',
    SELLER_LIST_COMPACT_VIEW: 'sellerListCompactView',
    SYI_NEW_LAYOUT_INFO_DISMISSED: 'syiNewLayoutInfoDismissed',
    SYI_DESCRIPTION_LANGUAGE_DISMISSED: 'syiDescriptionLanguageDismissed',
    BATCH_PAYOUTS_ALERT_DISMISSED: 'batchPayoutsAlertDismissed',
    // State caches
    CACHE_MESSAGING_BADGES: 'cache.messagingBadges',
    CACHE_RECENTLY_VIEWED_ITEMS: 'cache.recentlyViewedItems',
    CACHE_SYSTEM_MESSAGES: 'cache.systemMessages',
    // Apple ID login user
    APPLE_ID_USER: 'appleId.user'
};

const STORAGE_VALUES = {
    SAVE_SEARCH_HINT_CLICKED: 'CLOSE_CLICKED'
};

export { STORAGE_KEYS, STORAGE_VALUES };
